export default __webpack_public_path__ + "static/media/less.f649e2cf.svg";